
export function processSurveyColumns(surveyElements, editable=false){
	let headers = [];
	surveyElements.forEach( e => {
		let newCol = {};
		newCol.excludeFromProfiles = e.excludeFromProfiles;
		if( editable ){
			newCol.type = "text"; 
			newCol.inline = true;
		}
		switch (e.type){
			case "radiogroup":
			case "dropdown":
				newCol.options = e.choices;
				newCol.value = e.name;
				newCol.text = e.title; 
				newCol.multiple = false;
				if( editable ){		
					newCol.type = "select";
					newCol.selected = e.name;
					newCol.otherBindingOptions = {          
						'item-text': 'text',
						'item-value': 'value',
					};
				}
				headers.push( {...newCol} )
			break;
			case "checkbox":
				newCol.options = e.choices;
				newCol.value = e.name;
				newCol.text = e.title; 
				newCol.multiple = true;
				if( editable ){		
					newCol.type = "select";
					newCol.selected = e.name;
					newCol.otherBindingOptions = {          
						'item-text': 'text',
						'item-value': 'value',
					};
				}
				headers.push( {...newCol} )
			break;
			case "matrix":
				newCol.options = e.columns;
				newCol.multiple = false;
				if( editable ){								
					newCol.type = "select";
					newCol.otherBindingOptions = {          
						'item-text': 'text',
						'item-value': 'value',
					};
				}
				e.rows.forEach( r => {
					newCol.selected = e.name + "." + r.value;
					newCol.value = e.name + "." + r.value;
					newCol.text = e.title + " - " + r.text; 
					headers.push( {...newCol} )
				})
			break;
			default:
				newCol.value = e.name;
				newCol.text = e.title; 
				headers.push( {...newCol} )
			break;
		}


	})	

	return headers;		
}

export function processSurveyRows( responses, columns, editable=false ){
	let rows = [];
	responses.forEach( response => {
		let row = {}
		columns.forEach( c => {
			row[c.value] = response[c.value] ? response[c.value] : "";
		} )
		row.id = response.id;
		let flatData = {}
		for( var questionId in response.data ){
			let column = columns.find( h => h.value == questionId );
			if( column ){
				flatData[questionId] = response.data[questionId]
			}
			else{
				for( var subquestionId in response.data[questionId] ){
					let concatId = questionId+"."+subquestionId;
					column = columns.find( h => h.value == concatId );
					if( column ){
						flatData[concatId] = response.data[questionId][subquestionId]
					}
				}
			}
		}
		for( var colId in flatData ){
			row[colId] = flatData[colId];
			let column = columns.find( h => h.value == colId );
			if( column.options ){
				if( !editable ){
					if( column.multiple ){

						let answerStrings = flatData[colId].map( v => {
							var selectedCheckbox = column.options.find( o => o.value == v );
							if( selectedCheckbox ){
								return selectedCheckbox.text ? selectedCheckbox.text : selectedCheckbox.value
							}
						} );
						if( answerStrings ){
							row[colId] = answerStrings.join(", ")
						}
					}
					else{
						var selectedRadio = column.options.find( o => o.value == flatData[colId] );
						if( selectedRadio ){
							row[colId] = selectedRadio.text.length ? selectedRadio.text : selectedRadio.value;
						}
					}
				}
			}
		}
		rows.push( row )
	})	
	return rows;
}
